<div class="product-info-header" [class.small]="small" [class.medium]="medium">
  @if(showCodeAndBrandLine){
  <div class="code-and-brand-image">
    @if(sku){
    <span>Part code: {{ sku }}</span>
    } @if(manufacturer){ @if(manufacturer.asset){
    <img class="manufacturer-logo" [src]="manufacturer.asset.preview" [alt]="manufacturer.name" />
    } @else {
    <p class="manufacturer-name m-unset">{{ manufacturer.name }}</p>
    } }
  </div>
  }
  <div [class.brandAndNameInline]="manufacturer && brandAndNameInline">
    <a [routerLink]="router.url.includes('/product') ? null : ['/',vehicleTypeService.currentVehicleType,'product', slug]" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"  (click)="inCart && closeCartSidebar()"
      class="product-name">@if(quantity){ {{ quantity }} x }{{ name || "Unknown name" }}</a>

    @if(manufacturer && brandAndNameInline){ @if(manufacturer.asset){
    <img class="manufacturer-logo" [src]="manufacturer.asset.preview" [alt]="manufacturer.name" />
    } @else {
    <p class="manufacturer-name m-unset">{{ manufacturer.name }}</p>
    } }
  </div>

  @if (showLabels) {

  <!--
    -->
  <div class="product-labels">
    <!--
    pTooltip="Frí afhending í búðir okkar á Akureyri, Hafnarfirði og Reykjavík."
    -->
    <p-chip  [styleClass]="'free-delivery'"
      label="Frí afhending í búðir okkar á Akureyri, Hafnarfirði og Reykjavík." />

    @if(studdedTires){
    <p-chip [styleClass]="'studdedTires'" label="Nagladekk" />
    } @else if(studdableTires){
    <p-chip [styleClass]="'studdableTires'" label="Neglanleg dekk, án nagla" />
    }
    <!--
        <div class="extra-line">
    
    </div>
    -->

    <!--
            <div class="label sale">
          <span>Sale</span>
        </div>
        <div class="label discount-value">
          <span>-20%</span>
        </div>
      
    @if(discounts?.length > 0){
    @for(discount of discounts; track discount.description){
    <div class="label discount-value">
      <span>{{discount.description}}</span>
    </div>

    }
    }

    <div class="label free-delivery">
      <span>Frí afhending í búðir okkar á Akureyri, Hafnarfirði og Reykjavík.</span>
    </div>


    <div class="label free-shipping">
      <span>Free shipping</span>
    </div>
   
    @if(studdedTires){
    <div class="label studdedTires">
      <span>Nagladekk</span>
    </div>
    } @else if(studdableTires){
    <div class="label studdableTires">
      <span>Neglanleg dekk, án nagla</span>
    </div>
    }


      -->
  </div>
  }
  @if(stockLevel){

  <div class="stock-line">
    @if(stockLevel > 0){
      <p>{{ stockLevel }} in stock at supplier warehouse</p>
    } @else {
      <p><b>Sold out</b></p>
    }
  
  </div>
  
  }
</div>
